import { motion, AnimatePresence } from "framer-motion";
import { X, Lock, ShieldCheck, ArrowRight } from "lucide-react";
import { CLOVER_CHECKOUT_URL, PRODUCT } from "../lib/brand";
import { toast } from "sonner";

export const CloverCheckoutModal = ({ open, onClose, colorway, qty }) => {
  const total = (PRODUCT.price * qty).toFixed(2);

  const proceed = () => {
    if (CLOVER_CHECKOUT_URL) {
      window.location.href = CLOVER_CHECKOUT_URL;
    } else {
      toast.info("Clover checkout not linked yet", {
        description: "Paste your Clover Hosted Checkout URL in src/lib/brand.js to go live.",
      });
    }
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[60] flex items-end justify-center sm:items-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="clover-checkout-modal"
        >
          <div className="absolute inset-0 bg-[#212121]/70 backdrop-blur-sm" onClick={onClose} />
          <motion.div
            initial={{ y: 60, opacity: 0, scale: 0.98 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: 40, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="relative w-full max-w-md overflow-hidden rounded-t-3xl bg-white p-7 shadow-2xl sm:rounded-3xl"
          >
            <button
              onClick={onClose}
              data-testid="clover-modal-close"
              className="absolute right-5 top-5 grid h-9 w-9 place-items-center rounded-full bg-black/5 text-[#212121] transition hover:bg-black/10"
            >
              <X size={18} />
            </button>

            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#9E9E9E]">Order summary</p>
            <h3 className="font-display mt-2 text-3xl uppercase text-[#212121]">Your Featherbomb</h3>

            <div className="mt-6 space-y-4 rounded-2xl bg-[#F5F5F5] p-5">
              <div className="flex items-center justify-between text-sm">
                <span className="text-[#212121]/70">{PRODUCT.name} · {colorway?.name}</span>
                <span className="font-semibold">${PRODUCT.price.toFixed(2)}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-[#212121]/70">Quantity</span>
                <span className="font-semibold">×{qty}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-[#212121]/70">Shipping</span>
                <span className="font-semibold text-[#184786]">Free</span>
              </div>
              <div className="flex items-center justify-between border-t border-black/10 pt-4">
                <span className="font-bold uppercase tracking-wide">Total</span>
                <span data-testid="clover-modal-total" className="font-display text-2xl text-[#EE4026]">${total}</span>
              </div>
            </div>

            <button
              onClick={proceed}
              data-testid="clover-checkout-confirm-button"
              className="btn-primary mt-6 flex w-full items-center justify-center gap-2 rounded-full py-4 text-sm font-bold uppercase tracking-wide"
            >
              <Lock size={16} />
              Proceed to Clover Secure Checkout
              <ArrowRight size={16} />
            </button>
            <p className="mt-4 flex items-center justify-center gap-2 font-mono text-[11px] uppercase tracking-widest text-[#9E9E9E]">
              <ShieldCheck size={14} /> Encrypted payment · Powered by Clover
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
